import './Stats.css';
import {useSelector} from 'react-redux'








export default function Stats() {
  
  const stats =  useSelector((state) => state.CoursesReducer.stats) ;
  const statItems = [
  // { value: stats.nStudents, label: 'Students', suffix: '+' },
  { value: stats.nCourses, label: 'Courses', suffix: '' },
  { value: stats.nEquation, label: 'Equations ', suffix: '' },
  { value: stats.nProblems, label: 'Problems', suffix: '' },
  { value: stats.nNotebooks, label: 'Notebooks', suffix: '' },
  { value: stats.nFigure, label: 'Figures', suffix: '' },
  { value: stats.nIntFigure, label: 'Interactive Figures', suffix: '' },
  { value: stats.nAnimation, label: 'Animations', suffix: '' },
];

  return (
    <section className="stats-section">
      <div className="container">
        <div className="stats-section__head">
          <span className="stats-section__eyebrow">By the numbers</span>
          <h2 className="section-title stats-section__title">
            Real learning, real depth
          </h2>
          <p className="stats-section__sub">
            Every equation, figure, and problem is crafted to build genuine understanding — not surface familiarity.
          </p>
        </div>

        <div className="stats-grid">
          {statItems.map((item) => (
            <div key={item.label} className="stat-card">
              <span className="stat-card__value">
                {item?.value?.toLocaleString()}{item.suffix}
              </span>
              <span className="stat-card__label">{item.label}</span>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
